@use "theme/typographyV2" as typography;
@use "theme/breakpoints";
@use "./tokens";

$avatar-width: 70px;

.header {
  font-family: typography.$font-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 22px;
  line-height: 140%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: none;
  color: #143467;
  margin: 0;
  padding-bottom: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  @include breakpoints.desktop {
    font-size: 32px;
  }
}

.avatarContainer {
  position: absolute;
  top: 10px;
  right: var(--mobile-gutter);
  width: $avatar-width;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  // border: 1px solid var(--blue-01-at-30);
  // background-color: var(--gray-04);
  z-index: 0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;

  @include breakpoints.desktop {
    z-index: var(--float);
    right: 24px;
    top: 15px
  }
}

.card {
  position: relative;
  padding-bottom: 1px; // prevent margin collapse
}

.cardCustom {
  position: relative;
  padding-bottom: 1px; // prevent margin collapse
  display: flex;
  flex-direction: column;
}

.cardCustom > .instruction {
  margin-top: 0;
  margin-bottom: 0;
}

// breaking in local
// .cardCustom > .buttonContainer {
//   margin-top: 20px;
//   padding-bottom: 8px;
// }

.cardContainer {
  margin-bottom: tokens.$card-alley;

  @include breakpoints.desktop {
    margin-bottom: 0;
  }
}

.addToCalendarButton {
  color: var(--blue-01);

  @include breakpoints.desktop {
    position: absolute;
    top: 0;
    right: 24px;
  }
}

.textButton {
  @include typography.body-semibold;
  color: var(--black);
  margin: 0 4px;
  line-height: 100%;
}

.textButton:hover {
  color: var(--highlight-blue);
}

.dateContainer {
  padding-left: 48px;
  margin-bottom: 20px;
  margin-top: 24px;
  position: relative;
  background-image: url("~images/calendar.svg");
  background-repeat: no-repeat;
  background-position: 20px 2px;
  background-size: 16px;
  color: #143467;
  font-family: typography.$font-mont;
  font-weight: 400;
}

.date {
  @include breakpoints.desktop {
    margin-top: -10px;
  }
}

.instruction .date,
.instruction address {
  @include breakpoints.desktop {
    font-size: 20px;
    line-height: 140%;
    font-weight: 400;
  }
}

.doctor {
  margin-bottom: 8px;

  @include breakpoints.desktop {
    margin-bottom: 4px;
  }
}

.officeContainer {
  padding-left: 48px;
  margin-bottom: 24px;
  background-image: url("~images/pin.svg");
  background-repeat: no-repeat;
  background-position: 22px 4px;
  font-family: typography.$font-mont;
  color: #143467;
}

.checkinStatusContainer {
  padding-left: 48px;
  margin-bottom: 24px;
  background-image: url("~images/checkmark.svg");
  background-repeat: no-repeat;
  background-position: 20px;
  font-family: typography.$font-mont;
  color: var(--brand-indigo);
}

.ctas {
  margin-top: 8px;
  text-align: center;
  margin-left: auto;

  @include breakpoints.desktop {
    text-align: left;
    margin-left: var(--mobile-gutter);
  }
}

.instruction {
  border-radius: 20px;
  font-family: typography.$font-mont;
  background: #EEF5FC;
  margin-top: 8px;
  margin-bottom: 20px;
  opacity: 1;
  gap: 10px;
  text-align: center;
  width: 100%;
  padding-top: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  color: #143467;
  font-size: 16px;

  @include breakpoints.desktop {
    width: 520px;
    min-height: 137px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 24px;
    padding-right: 20px;
    padding-bottom: 24px;
    padding-left: 20px;
    gap: 10px;
    opacity: 1;
    font-weight: 400;
    font-style: normal;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    font-size: 20px;
  }
}

.instruction > div:last-child {
  overflow-wrap: anywhere;
  word-break: break-word;

  @include breakpoints.desktop {
    max-width: 480px;
    margin: 0 auto;
  }
}

.buttonContainer {
  display: flex;
  width: 100%;
}

.bookAppointmentButton{
  flex: 1 1 auto;
  font-family: typography.$font-mont;
  font-weight: 600;
  font-style: normal;
  font-size: 16px;
  color: #ffffff;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: none;

  height: 48px;
  border-radius: 20px;

  > * {
    min-height: 44px;
  }
}

.checkInButtonContainer {
  display: flex;
  margin: 12px 0;
  position: relative;
  border-radius: 100px;
}

.customCheckInButtonContainer {
  display: flex;
  margin: 12px 0;
  position: relative;
  border-radius: 100px;
  background: #e0f7fa;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.incompleteCheckinButton {
  &::after {
    position: absolute;
    content: "";
    bottom: 0;
    left: 0;
    height: 6px;
    background-color: rgb(255 255 255 / 50%);
    width: 50%;
  }
}

.insuranceContainer {
  padding-left: 28px;
  margin-bottom: 28px;
  position: relative;
  background-image: url("~images/rectangle.svg");
  background-repeat: no-repeat;
  background-position: 8px 2px;

  @include breakpoints.desktop {
    padding-left: 44px;
    background-position: 20px 2px;
  }
}

.insuranceHeading {
  @include typography.body-semibold;
  margin-bottom: 8px;
  color: var(--brand-indigo);
}

.insuranceNotFoundSubtext {
  @include typography.caption;
  padding-right: 0;
  color: var(--brand-indigo);

  @include breakpoints.desktop {
    padding-right: 144px;
  }
}

.insuranceHeader {
  font-family: typography.$font-serif;
  color: var(--brand-indigo);
  line-height: 100%;
  margin: 0;
  height: 72px;
  font-weight: 400;
  font-style: normal;
  font-size: 22px;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: none;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  @include breakpoints.desktop {
    font-size: 32px;
  }
}

.singleLineAddress {
  padding-left: 10px;
  background-position: 0 4px;
}

.highlight {
  padding-left: 48px;
    margin-bottom: 24px;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDJDNi40OCAyIDIgNi40OCAyIDEyQzIgMTcuNTIgNi40OCAyMiAxMiAyMkMxNy41MiAyMiAyMiAxNy41MiAyMiAxMkMyMiA2LjQ4IDE3LjUyIDIgMTIgMlpNMTMgMTdIMTFWMTFIMTNWMTdaTTEzIDlIMTFWN0gxM1Y5WiIgZmlsbD0iIzQwNjY4QyIvPgo8L3N2Zz4=);
    background-repeat: no-repeat;
    background-position: 15px 4px;
    background-color: yellow;
    address {
      font-style: normal;
    }
}

.dummyDiv {
  height: 20px;
}


.saveTime {
  color: #143467;
  font-family: typography.$font-mont;
  font-style: normal;
  font-weight: 400;
}

.subscriberInfo {
  font-family: typography.$font-mont;
  font-size: 14px;
  color: var(--brand-indigo);

  @include breakpoints.desktop {
    font-size: 16px;
  }
}